// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/border-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/EditStoryModalBOrder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/ingredientstop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/ingredientbottom.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/dark-blue-border-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/yellow-border-modal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/behind-bg-section.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/yellow-border-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images/white-border-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images/login-first-badalbg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/images/login-first-red-line-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/images/StoryBorderCreate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/images/mobile-login-first-badalbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storypage_modal__08wW0,
.storypage_modaltwo__tPeSU {
  border: 0;
  position: fixed;
  right: 0;
  background-color: #1d1d1c59;
  width: 100%;
}
.storypage_ReactModal__Overlay--after-open__pfg\\+Q,
.storypage_modal__08wW0,
.storypage_modaltwo__tPeSU {
  background-color: #1d1d1c59;
}
.storypage_btnFill__Yovh4,
.storypage_modalstoryflow__2L4ss h4,
.storypage_modalstoryflow__2L4ss input {
  font-family: Kodchasan, sans-serif;
}
.storypage_modal__08wW0,
.storypage_modalconfirm__vMvVE,
.storypage_modaltwo__tPeSU {
  left: 0;
  bottom: 0;
  height: 100%;
}
.storypage_modal__08wW0 {
  padding-top: 12%;
}
.storypage_modaltwo__tPeSU {
  padding-top: 7%;
}
.storypage_modalEditProfile__qEykb {
  background: #d9eb41;
  border: 5px solid #000;
  border-radius: 65px;
  text-align: center;
  margin: auto;
  width: 75%;
  padding: 30px;
}
.storypage_modalEditProfile__qEykb button {
  display: block;
  margin: 0 auto 20px;
}
.storypage_modalEditProfile__qEykb p {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  color: #1c2452;
  margin-bottom: 25px;
}
.storypage_modalEditProfile__qEykb button {
  font-size: 25px;
}
.storypage_modalEditProfile__qEykb .storypage_profile_top_img__6HoMI img {
  max-width: 125px;
}
.storypage_Catputure__gJVDN {
  flex-direction: row;
  flex: 1 1;
  display: flex;
  margin-top: 15px;
}
.storypage_btnFill__Yovh4,
.storypage_btnUnfill__Gtvp2 {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  padding: 0 50px;
  margin: 0 10px;
  text-align: center;
}
.storypage_btnUnfill__Gtvp2 {
  border: 3px solid #0d5268;
  background-color: transparent;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 11px;
  border-image-outset: 0 0 8px 0;
  color: #0d5268;
}
.storypage_btnFill__Yovh4 {
  color: #fff;
  background-color: #0d5268;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 11px;
  border-image-outset: 8px 8px 14px 8px;
}
.storypage_modalstoryflow__2L4ss {
  background: #f2dd4e;
  border: 3px solid #000;
  border-radius: 6px;
  max-width: 50%;
  margin: auto;
  padding: 30px;
  text-align: center;
}
.storypage_modalstoryflow__2L4ss h4 {
  text-align: center;
  font-size: 30px;
  margin-bottom: 10px;
}
.storypage_modalstoryflow__2L4ss p {
  font-weight: 400;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  margin-bottom: 33px;
}
.storypage_modalstoryflow__2L4ss .storypage_modalstoryflowSubdiv__Ngae7 p {
  margin-bottom: 0;
  text-align: left;
}
.storypage_modalstoryflow__2L4ss input {
  background: #fff;
  border-radius: 15px;
  width: 100%;
  padding: 15px;
  margin-bottom: 30px;
  font-size: 22px;
  font-weight: 600;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border-image-repeat: stretch;
  border-image-slice: 16;
  border-image-width: 19px;
  border-image-outset: 1;
  border-style: solid;
  margin-top: 10px;
}
.storypage_ModalStoryPage__emFbl,
.storypage_modalIngredients__eg6jc {
  border: 5px solid #000;
  text-align: center;
  margin: auto;
}
.storypage_modalstoryflow__2L4ss button {
  margin: 0 15px;
}
.storypage_modalMyStories__bsi\\+7 {
  position: absolute;
  right: 10%;
  top: 25%;
}
.storypage_ModalStoryPage__emFbl,
.storypage_modalAvatar__DQNG6,
.storypage_modalFooterMain__rFF2X,
.storypage_modalIngredients__eg6jc,
.storypage_modalIngredientsshareMobile__B2ygl,
.storypage_modalmuniaModalMain__U57b2,
.storypage_modalpackage__OjhVY {
  position: relative;
}
.storypage_modalIngredients__eg6jc {
  background: #f2dd4e;
  border-radius: 65px 65px 0 0;
  padding: 30px;
  width: 80%;
  border-bottom: 0;
}
.storypage_modalIngredients__eg6jc p {
  font-weight: 600;
  font-size: 36px;
  line-height: 47px;
  color: #000;
  margin-bottom: 36px;
}
.storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx {
  background: #56cdd5;
  transform: matrix(1, -0.09, 0.07, 1, 0, 0);
  border: 4px solid #000;
  position: relative;
  width: 50%;
  margin: auto;
  padding-top: 20px;
  z-index: 1;
}
.storypage_modalpackage__OjhVY .storypage_modalIngredientsInner__0u8hx::before {
  content: "";
  position: absolute;
  top: 10%;
  left: 28%;
  width: 89px;
  height: 87px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  z-index: -1;
}
.storypage_modalpackage__OjhVY .storypage_modalIngredientsInner__0u8hx::after {
  content: "";
  position: absolute;
  bottom: 15%;
  right: 23%;
  width: 185px;
  height: 122px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  z-index: -1;
}
.storypage_modalIngredients__eg6jc .storypage_modalIngredientsInnerInfo__P6bsl {
  background: #232876;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
}
.storypage_modalIngredients__eg6jc .storypage_modalIngredientsInnerInfo__P6bsl img {
  width: 57px;
  margin-right: 10px;
}
.storypage_modalIngredients__eg6jc .storypage_modalIngredientsInnerInfo__P6bsl .storypage_modalIngredientsInnerInfoimg__sIn9G img {
  width: 95px;
}
.storypage_modalIngredients__eg6jc .storypage_modalIngredientsInnerInfo__P6bsl span {
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  color: #fff;
}
.storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx p {
  margin-bottom: 10px;
  margin-top: 10px;
}
.storypage_modalIngredients__eg6jc .storypage_HeartYellowbtn__eMFOt {
  position: absolute;
  bottom: 5%;
  right: 10%;
}
.storypage_modalIngredientsshare__1OpOR {
  width: 80%;
  margin: auto;
  background: #0d5268;
  border-radius: 0 0 65px 65px;
  padding: 16px 54px;
  border: 4px solid #000;
}
.storypage_modalIngredientsshare__1OpOR p {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #fff;
}
.storypage_modalIngredientsshare__1OpOR a,
.storypage_modalIngredientsshareMobile__B2ygl .storypage_modalIngredientsshareInner__Ho9xT a {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  color: #fff;
  text-align: center;
}
.storypage_modalIngredientsshare__1OpOR a span,
.storypage_modalIngredientsshareMobile__B2ygl .storypage_modalIngredientsshareInner__Ho9xT a span {
  display: block;
}
.storypage_modalIngredientsshare__1OpOR .storypage_modalIngredientsshareInner__Ho9xT {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.storypage_modalIngredientsshare__1OpOR .storypage_modalIngredientsshareInner__Ho9xT img {
  width: 118px;
}
.storypage_modalpackage__OjhVY .storypage_modalIngredientsInner__0u8hx {
  background: 0 0;
  transform: unset;
  border: 0;
}
.storypage_ModalpacakageNextcontent__bwdkW {
  background: #56cdd5;
  border-radius: 0 0 65px 65px;
  width: 70%;
  margin: auto;
  border: 5px solid #000;
  text-align: center;
  padding: 23px 74px;
}
.storypage_ModalpacakageNextcontent__bwdkW .storypage_StoryFlowInfoBtn__BhD90 button {
  margin-top: 40px;
  line-height: 36px;
}
.storypage_ModalpacakageNextcontent__bwdkW .storypage_StoryFlowInfoBtn__BhD90 button img {
  left: -58px;
  top: -53px;
  width: 133px;
}
.storypage_ModalpacakageNextcontent__bwdkW .storypage_StoryFlowInfoBtn__BhD90 {
  margin-top: -90px;
}
.storypage_ModalpacakageNextcontent__bwdkW p {
  font-weight: 500;
  font-size: 36px;
  line-height: 42px;
  color: #1c2452;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  border-image-repeat: stretch;
  border-image-slice: 16;
  border-image-width: 15px;
  border-image-outset: inherit;
  border-style: solid;
  padding: 30px 0 90px;
}
.storypage_storypage_modalpackage__Zt0Nk .storypage_modalIngredientsInner__0u8hx::before {
  top: 6%;
  left: -16px;
}
.storypage_storypage_modalpackage__Zt0Nk .storypage_modalIngredientsInner__0u8hx::after {
  bottom: 15%;
  right: -90px;
}
.storypage_modalAvatar__DQNG6 {
  background: #d9eb41;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  border-image-repeat: stretch;
  border-image-slice: 16;
  border-image-width: 15px;
  border-image-outset: 8px;
  border-style: solid;
  padding: 50px 0 20px;
  width: 50%;
  text-align: center;
  margin: auto;
  z-index: 10;
}
.storypage_modalAvatar__DQNG6 img {
  width: 211px;
}
.storypage_modalAvatar__DQNG6 p {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  margin: 10px 0 35px;
}
.storypage_ModalEditSubmission_Draft__ROV2c {
  background: #0d5268;
  border: 1px solid #000;
  width: 78%;
  margin: auto;
  text-align: center;
  padding: 32px;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  border-image-repeat: stretch;
  border-image-slice: 16;
  border-image-width: 10px;
  border-image-outset: 11px;
}
.storypage_ModalEditSubmission_Draft__ROV2c .storypage_ModalEditSubmission_DraftInner__KDucq h2 {
  color: #fff;
  font-weight: 700;
  font-size: 48px;
  line-height: 56px;
  margin-bottom: 39px;
}
.storypage_ModalEditSubmission_Draft__ROV2c .storypage_ModalEditSubmission_DraftInner__KDucq p {
  font-weight: 600;
  font-size: 34px;
  line-height: 39px;
  text-align: center;
  color: #fff;
  margin-bottom: 38px;
}
.storypage_ModalEditSubmission_Draft__ROV2c .storypage_ModalEditSubmission_DraftInner__KDucq p span {
  display: block;
  margin: 20px 0;
}
.storypage_ModalEditSubmission_Draft__ROV2c .storypage_ModalEditSubmission_DraftInner__KDucq button {
  color: #0d5268;
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  background: #d9eb41;
  padding: 10px 15px;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  border-image-repeat: stretch;
  border-image-slice: 16;
  border-image-width: 10px;
  border-image-outset: 9px;
  border-style: solid;
}
.storypage_ModalStoryPage__emFbl {
  background: #dffdff;
  border-radius: 51px;
  padding: 15px;
  width: 415px;
}
.storypage_ModalStoryPage__emFbl p {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #0d5268;
  margin-bottom: 15px;
}
.storypage_ModalStoryPage__emFbl h1 {
  font-family: "Roof runners active";
  font-weight: 700;
  font-size: 36px;
  line-height: 41px;
  text-align: center;
  color: #0d5268;
  margin-bottom: -8px;
}
.storypage_ModalStoryPage__emFbl button {
  font-weight: 700;
  font-size: 22px;
  line-height: 31px;
}
.storypage_ModalStoryPage__emFbl span {
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #000;
  margin: 20px 0 10px;
  display: block;
}
.storypage_ModalStoryPage__emFbl .storypage_ModalStoryPageInner__GmIEz p {
  font-weight: 600;
  font-size: 24px;
  line-height: 25px;
  text-align: center;
  color: #000;
}
.storypage_ModalStoryPage__emFbl .storypage_ModalStoryPageInner__GmIEz button {
  padding: 8px 20px;
  font-size: 22px;
  line-height: 31px;
}
.storypage_ModalStoryPage__emFbl .storypage_sharebtnimg__J6hf- {
  position: absolute;
  top: -2%;
  right: -15px;
  cursor: pointer;
  width: 50px;
}
.storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx::before {
  content: "";
  position: absolute;
  top: 5%;
  left: 5px;
  width: 89px;
  height: 87px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  z-index: -1;
}
.storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx::after {
  content: "";
  position: absolute;
  bottom: 24%;
  right: -12px;
  width: 185px;
  height: 122px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  z-index: -1;
}
.storypage_modalpackage__OjhVY {
  background: #f2dd4e;
  border: 5px solid #000;
  border-radius: 65px 65px 0 0;
  padding: 30px;
  width: 70%;
  margin: auto;
  text-align: center;
  border-bottom: 0;
  z-index: 1;
}
.storypage_modalIngredientsshareMobile__B2ygl {
  background: #0d5268;
  border-radius: 0 0 6px 6px;
  padding: 17px 0;
  border: 4px solid #000;
}
.storypage_modalIngredientsshareMobile__B2ygl .storypage_modalIngredientsshareInner__Ho9xT a img {
  width: 80px;
}
.storypage_modalIngredientsshareMobile__B2ygl .storypage_modalIngredientsshareInner__Ho9xT {
  display: flex;
  justify-content: space-around;
}
.storypage_modalmuniaModal__OaW3F {
  background: #0d5268;
  border: 5px solid #000;
  border-radius: 42px;
  text-align: center;
  padding: 0 20px 10px;
  width: 60%;
  margin: auto;
}
.storypage_NoDraftModal__Coqa1,
.storypage_modalFooterMain__rFF2X {
  text-align: center;
  background: #56cdd5;
  border: 4px solid #000;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}
.storypage_modalmuniaModalMain__U57b2 .storypage_sharebtnimg__J6hf- {
  position: absolute;
  top: -20px;
  right: 17%;
  cursor: pointer;
}
.storypage_NoDraftModal__Coqa1 .storypage_sharebtnimg__J6hf-,
.storypage_SubmittedSuccesModal__Loe5Q .storypage_sharebtnimg__J6hf-,
.storypage_modalFooterMain__rFF2X .storypage_sharebtnimg__J6hf- {
  top: -14px;
  right: -15px;
  position: absolute;
}
.storypage_modalmuniaModal__OaW3F h5 {
  text-align: center;
  color: #fff;
  font-size: 25px;
  line-height: 35px;
}
.storypage_modalmuniaModal__OaW3F p {
  font-style: italic;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  color: #fff;
}
.storypage_NoDraftModal__Coqa1 h2,
.storypage_SubmittedSuccesModal__Loe5Q h2,
.storypage_modalFooterMain__rFF2X h2 {
  font-size: 48px;
  line-height: 58px;
}
.storypage_modalmuniaModal__OaW3F .storypage_modalmuniaInner__GcajS {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px 0;
}
.storypage_modalmuniaModal__OaW3F .storypage_modalmuniaInner__GcajS a {
  font-style: italic;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #fff;
  margin-right: 12px;
}
.storypage_modalmuniaModal__OaW3F .storypage_modalmuniaInner__GcajS img {
  margin-right: 12px;
}
.storypage_modalmuniaModal__OaW3F .storypage_modalmuniabtn__-d0u0 button {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 11px;
  border-image-outset: 0;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #fff;
  border-style: solid;
  display: inline-block;
  background: 0 0;
  padding: 10px 15px;
}
.storypage_modalmuniaModal__OaW3F .storypage_modalmuniaModalTop__vpKLs img:first-child {
  width: 100px;
}
.storypage_modalmuniaModal__OaW3F .storypage_modalmuniaModalTop__vpKLs .storypage_modalmuniaHelloImg__HXs5o {
  margin-left: -35px;
  width: 160px;
}
.storypage_modalFooterMain__rFF2X {
  border-radius: 52px;
  padding: 30px;
}
.storypage_modalFooterMain__rFF2X .storypage_sharebtnimg__J6hf- {
  cursor: pointer;
}
.storypage_modalFooterMain__rFF2X h2 {
  margin: 10px 0 45px;
}
.storypage_NoDraftModal__Coqa1 {
  padding: 50px;
  width: 65%;
  border-radius: 52px;
  position: relative;
  margin: auto;
}
.storypage_SubmittedSuccesModal__Loe5Q,
.storypage_modalLoginRegister__r6NDz {
  border: 4px solid #000;
  position: relative;
  text-align: center;
}
.storypage_NoDraftModal__Coqa1 h2 {
  margin: 30px 0;
}
.storypage_NoDraftModal__Coqa1 .storypage_NoDraftFrame__KCqPo {
  width: 150px;
}
.storypage_SubmittedSuccesModal__Loe5Q {
  background: #d9eb41;
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
  border-radius: 52px;
  padding: 30px;
  width: 65%;
  margin: auto;
}
.storypage_SubmittedSuccesModal__Loe5Q h2 {
  margin: 35px 0 45px;
}
.storypage_modalLoginRegister__r6NDz {
  background: #f2dd4e;
  border-radius: 50px;
  padding: 80px 30px 50px;
  z-index: 1;
}
.storypage_modalLoginRegister__r6NDz .storypage_sharebtnimg__J6hf- {
  position: absolute;
  top: -20px;
  right: -20px;
  cursor: pointer;
}
.storypage_modalLoginRegister__r6NDz button {
  display: inline-block;
  margin: 35px 15px;
  width: 35%;
}
.storypage_modalLoginRegister__r6NDz::before {
  content: "";
  position: absolute;
  top: 25px;
  right: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat;
  width: 124px;
  height: 123px;
  z-index: -1;
}
.storypage_modalLoginRegister__r6NDz::after {
  content: "";
  position: absolute;
  bottom: 130px;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat;
  width: 146px;
  height: 102px;
}
.storypage_ModalSelectIngredientStory__saNSf {
  background: #56cdd5;
  border: 4px solid #000;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 52px;
  position: relative;
  text-align: center;
  padding: 40px;
}
.storypage_ModalSelectIngredientStory__saNSf .storypage_backbtn__sOeCx {
  position: absolute;
  right: -12px;
  top: -12px;
}
.storypage_ModalSelectIngredientStory__saNSf img.storypage_NoDraftFrame__KCqPo {
  width: 125px;
  margin: auto;
}
.storypage_ModalSelectIngredientStory__saNSf h2 {
  font-weight: 700;
  font-size: 64px;
  line-height: 77px;
  text-align: center;
  color: #000;
  margin: 30px 0;
}
.storypage_ModalStoryPicker__L6OIH {
  border: 5px solid #000;
  border-radius: 60px;
  text-align: center;
}
.storypage_ModalStoryPicker__L6OIH .storypage_ModalStoryPickerTop__BMFxI {
  background: #56cdd5;
  border-radius: 60px 60px 0 0;
  padding: 20px;
}
.storypage_ModalStoryPicker__L6OIH .storypage_ModalStoryPickerBottom__QYwuI {
  background: #f2dd4e;
  border-radius: 0 0 60px 60px;
  padding: 20px;
  margin-top: -2px;
}
.storypage_ModalStoryPicker__L6OIH .storypage_ModalStoryPickerTop__BMFxI .storypage_ModalStoryPickerTopInner__z47b5 {
  display: flex;
  justify-content: center;
}
.storypage_ModalStoryPickerTop__BMFxI p {
  font-weight: 600;
  font-size: 32px;
  line-height: 42px;
  text-align: center;
  color: #000;
  margin-bottom: 15px;
}
.storypage_ModalStoryPicker__L6OIH .storypage_dashedLine__tSgnb {
  background: #f2dd4e;
}
.storypage_ModalStoryPicker__L6OIH .storypage_ModalStoryPickerBottom__QYwuI button {
  margin-top: 22px;
}
.storypage_ModalStoryPicker__L6OIH .storypage_ModalStoryPickerBottom__QYwuI button.storypage_storyBtn__\\+THNH {
  font-weight: 600;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
  padding: 12px 30px !important;
  background: #56cdd5;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  border-image-repeat: stretch;
  border-image-slice: 27;
  border-image-width: 25px;
  border-image-outset: 5px;
  border-radius: 40px;
  border-style: solid;
  margin-top: 0;
}
.storypage_ModalStoryPicker__L6OIH .storypage_ModalStoryPickerBottom__QYwuI p {
  font-weight: 500;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  color: #000;
  margin: 10px 0;
}
.storypage_ModalStoryPickerTop__BMFxI .storypage_ModalStoryPickerTopInner__z47b5 p {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
  margin-bottom: 0;
}
.storypage_ModalStoryPickerBottom__QYwuI .storypage_CarouselPara__HPD-b p {
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  color: #000;
}
.storypage_ModalStoryPickerTop__BMFxI .storypage_ModalStoryPickerTopInner__z47b5 img {
  width: 188px;
  margin: 0 15px;
}
.storypage_ModalEditSubmission_Draft__ROV2c a {
  top: -12px;
}
.storypage_newScreenModal__GZFZ4 .storypage_modalIngredients__eg6jc {
  border: 0;
  border-radius: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
}
.storypage_newScreenModal__GZFZ4 .storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx {
  width: 110%;
  margin: 45px -30px 43px -17px;
  z-index: 0;
}
.storypage_newScreenModal__GZFZ4
  .storypage_modalIngredients__eg6jc
  .storypage_modalIngredientsInner__0u8hx
  .storypage_modalIngredientsInnerInfo__P6bsl
  span {
  font-size: 24px !important;
  line-height: 31px !important;
}
.storypage_newScreenModal__GZFZ4 .storypage_modalIngredients__eg6jc .storypage_HeartYellowbtn__eMFOt {
  position: inherit;
  bottom: 5%;
  right: inherit;
  text-align: right;
  width: auto;
}
.storypage_modalstoryflow__2L4ss button {
  width: 43%;
}
.storypage_NoDraftModal__Coqa1 .storypage_sharebtnimg__J6hf-,
.storypage_SubmittedSuccesModal__Loe5Q .storypage_sharebtnimg__J6hf- {
  width: 80px;
  cursor: pointer;
}
@media (max-width: 1199px) {
  .storypage_modalAvatar__DQNG6 .storypage_modalAvatarLeftImg__HHB5r {
    left: 40px !important;
  }
  .storypage_ModalEditSubmission_Draft__ROV2c,
  .storypage_modalAvatar__DQNG6 {
    width: 100%;
  }
  .storypage_modalAvatar__DQNG6 .storypage_modalAvatarRightImg__WJM-f {
    right: 75px !important;
  }
  .storypage_modalmuniaModalMain__U57b2 .storypage_sharebtnimg__J6hf- {
    right: 13%;
    cursor: pointer;
  }
  .storypage_modalmuniaModal__OaW3F {
    width: 70%;
  }
  .storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx::before {
    left: 12%;
  }
  .storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx::after {
    bottom: 30%;
    right: 0;
  }
  .storypage_modalpackage__OjhVY .storypage_modalIngredientsInner__0u8hx::after {
    right: 92px;
  }
  .storypage_modalpackage__OjhVY .storypage_modalIngredientsInner__0u8hx::before {
    left: 22%;
  }
  .storypage_ModalpacakageNextcontent__bwdkW p {
    font-size: 25px;
    line-height: 30px;
  }
  .storypage_ModalpacakageNextcontent__bwdkW {
    padding: 23px 25px;
    width: 70%;
  }
  .storypage_modalIngredients__eg6jc,
  .storypage_modalIngredientsshare__1OpOR {
    width: 75%;
  }
  .storypage_ModalpacakageNextcontent__bwdkW .storypage_StoryFlowInfoBtn__BhD90 button {
    font-size: 25px;
    line-height: 30px;
    padding: 0 65px;
  }
  .storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx {
    width: 90%;
  }
  .storypage_modalIngredientsshare__1OpOR .storypage_modalIngredientsshareInner__Ho9xT img {
    width: 80px;
  }
  .storypage_modalstoryflow__2L4ss {
    max-width: 75%;
  }
}
@media (max-width: 991px) {
  .storypage_modalLoginRegister__r6NDz .storypage_sharebtnimg__J6hf- {
    width: 18%;
    cursor: pointer;
  }
  .storypage_modalLoginRegister__r6NDz {
    width: 100%;
    margin: auto;
  }
  .storypage_modalmuniaModalMain__U57b2 .storypage_sharebtnimg__J6hf- {
    right: 0;
    cursor: pointer;
  }
  .storypage_ModalpacakageNextcontent__bwdkW,
  .storypage_modalIngredients__eg6jc,
  .storypage_modalIngredientsshare__1OpOR,
  .storypage_modalmuniaModal__OaW3F,
  .storypage_modalpackage__OjhVY {
    width: 100%;
  }
  .storypage_ModalStoryPage__emFbl {
    margin-top: 3%;
  }
}
@media (min-width: 768px) {
  .storypage_modalIngredients__eg6jc .storypage_sharebtnMobile__sJRoB,
  .storypage_modalIngredientsshareMobile__B2ygl {
    display: none;
  }
}
@media (max-width: 450px) {
  .storypage_modalLoginRegister__r6NDz {
    width: 100%;
  }
}
.storypage_modalconfirm__vMvVE {
  border: 0;
  background-color: #1d1d1c59;
  position: fixed;
  right: 0;
  width: 100%;
}
.storypage_modalMyStories__bsi\\+7 .storypage_sharebtnlink__TJ10S {
  width: 168px;
  padding: 15px 33px;
  background: #0d5268;
  border: 4px solid #000;
  border-radius: 10px;
  text-align: center;
  position: relative;
}
.storypage_sharebtnlink__TJ10S .storypage_sharebtnimg__J6hf- {
  position: absolute;
  top: -4%;
  right: -25%;
}
.storypage_sharebtnlink__TJ10S p {
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
  color: #fff;
  margin-bottom: 22px;
}
.storypage_sharebtnlink__TJ10S img {
  width: 70px;
}
.storypage_sharebtnlink__TJ10S a {
  margin-bottom: 20px;
  display: block;
}
.storypage_sharebtnlink__TJ10S span {
  font-weight: 600;
  font-size: 19px;
  line-height: 25px;
  color: #fff;
}
@media (max-width: 767px) {
  .storypage_ModalEditSubmission_Draft__ROV2c {
    margin-top: 70px;
  }
  .storypage_ModalStoryPicker__L6OIH .storypage_ModalStoryPickerTop__BMFxI .storypage_ModalStoryPickerTopInner__z47b5,
  .storypage_modalMyStories__bsi\\+7 .storypage_modalMyStoriesMobile__U0lr4 a span {
    display: block;
  }
  .storypage_ModalStoryPicker__L6OIH .storypage_ModalStoryPickerTop__BMFxI .storypage_ModalStoryPickerTopInner__z47b5 p {
    font-size: 22px;
    line-height: 28px;
    margin: 20px 0;
  }
  .storypage_modalLoginRegister__r6NDz button {
    width: 85%;
    margin: 15px;
  }
  .storypage_modalLoginRegister__r6NDz h2 {
    margin-bottom: 15px;
    font-size: 30px;
    line-height: 40px;
  }
  .storypage_modalLoginRegister__r6NDz {
    padding: 30px 40px;
  }
  .storypage_modalLoginRegister__r6NDz::before {
    top: 10px;
    right: 0;
    width: 70px;
    height: 70px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  }
  .storypage_modalLoginRegister__r6NDz::after {
    z-index: -1;
    bottom: 7px;
  }
  .storypage_NoDraftModal__Coqa1,
  .storypage_SubmittedSuccesModal__Loe5Q,
  .storypage_modalEditProfile__qEykb,
  .storypage_modalIngredients__eg6jc,
  .storypage_modalLoginRegister__r6NDz {
    width: 100%;
  }
  .storypage_NoDraftModal__Coqa1 .storypage_sharebtnimg__J6hf-,
  .storypage_SubmittedSuccesModal__Loe5Q .storypage_sharebtnimg__J6hf- {
    width: 60px;
  }
  .storypage_SubmittedSuccesModal__Loe5Q h2 {
    font-size: 40px;
    line-height: 45px;
  }
  .storypage_ModalMainNew__-ApCg {
    justify-content: space-around;
  }
  .storypage_modalAvatar__DQNG6 .storypage_modalAvatarLeftImg__HHB5r {
    left: 19px !important;
    top: -12px !important;
  }
  .storypage_modalAvatar__DQNG6 .storypage_modalAvatarRightImg__WJM-f {
    right: 30px !important;
  }
  .storypage_modalEditProfile__qEykb p {
    font-size: 18px;
    line-height: 23px;
  }
  .storypage_modalEditProfile__qEykb button {
    font-size: 18px;
    line-height: 29px;
  }
  .storypage_ModalEditSubmission_Draft__ROV2c a {
    top: -5px;
  }
  .storypage_modalFooterMain__rFF2X .storypage_sharebtnimg__J6hf- {
    width: 50px;
  }
  .storypage_NoDraftModal__Coqa1 h2 {
    font-size: 35px;
    line-height: 45px;
  }
  .storypage_NoDraftModal__Coqa1 .storypage_NoDraftFrame__KCqPo {
    width: 100px;
  }
  .storypage_ModalSelectIngredientStory__saNSf {
    width: 75%;
    margin: auto;
    padding: 30px 20px;
  }
  .storypage_ModalSelectIngredientStory__saNSf img.storypage_NoDraftFrame__KCqPo {
    width: 75px;
  }
  .storypage_ModalSelectIngredientStory__saNSf h2 {
    font-size: 40px;
    line-height: 48px;
    margin: 20px 0;
  }
  .storypage_ModalSelectIngredientStory__saNSf h2 br,
  .storypage_modalIngredientsshare__1OpOR,
  .storypage_modalstoryflow__2L4ss p br {
    display: none;
  }
  .storypage_modalLoginRegister__r6NDz .storypage_sharebtnimg__J6hf- {
    width: 50px;
    right: -11px;
    top: -10px;
    cursor: pointer;
  }
  .storypage_modalFooterMain__rFF2X h2 {
    font-size: 40px;
    line-height: 48px;
    margin: 15px 0 30px;
  }
  .storypage_modalmuniaModal__OaW3F p {
    font-size: 15px;
    line-height: 21px;
  }
  .storypage_modalIngredients__eg6jc .storypage_HeartYellowbtn__eMFOt {
    bottom: 0;
    right: 3%;
    width: 50px;
  }
  .storypage_ModalStoryPage__emFbl {
    margin-top: 2%;
    width: 100%;
  }
  .storypage_ModalStoryPage__emFbl button {
    font-size: 26px;
    line-height: 31px;
  }
  .storypage_modalIngredients__eg6jc p {
    font-size: 25px;
    line-height: 30px;
  }
  .storypage_modalpackage__OjhVY .storypage_modalIngredientsInner__0u8hx img {
    width: 40%;
  }
  .storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx img {
    width: 65%;
  }
  .storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx .storypage_modalIngredientsInnerInfo__P6bsl img {
    width: 30%;
  }
  .storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx .storypage_modalIngredientsInnerInfo__P6bsl {
    text-align: left;
  }
  .storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx .storypage_modalIngredientsInnerInfo__P6bsl span {
    font-size: 18px;
    line-height: 25px;
  }
  .storypage_modalIngredients__eg6jc
    .storypage_modalIngredientsInner__0u8hx
    .storypage_modalIngredientsInnerInfo__P6bsl
    .storypage_modalIngredientsInnerInfoimg__sIn9G {
    text-align: right;
  }
  .storypage_modalIngredients__eg6jc .storypage_modalIngredientsInner__0u8hx .storypage_modalIngredientsInnerInfoimg__sIn9G img {
    width: 50%;
    margin-right: 30px;
  }
  .storypage_modalpackage__OjhVY .storypage_modalIngredientsInner__0u8hx::after {
    bottom: 17%;
    right: 21px;
  }
  .storypage_modalpackage__OjhVY .storypage_modalIngredientsInner__0u8hx::before {
    top: 4%;
    left: 20%;
  }
  .storypage_ModalpacakageNextcontent__bwdkW p {
    font-size: 22px;
    line-height: 25px;
    padding: 15px 0 70px;
  }
  .storypage_ModalEditSubmission_Draft__ROV2c {
    width: 100%;
    padding: 10px 10px 20px;
  }
  .storypage_ModalEditSubmission_Draft__ROV2c .storypage_ModalEditSubmission_DraftInner__KDucq p {
    font-size: 18px !important;
    line-height: 21px !important;
  }
  .storypage_ModalEditSubmission_Draft__ROV2c .storypage_ModalEditSubmission_DraftInner__KDucq button {
    font-size: 24px;
    line-height: 31px;
    padding: 5px 10px;
  }
  .storypage_ModalEditSubmission_Draft__ROV2c .storypage_ModalEditSubmission_DraftInner__KDucq h2 {
    font-size: 24px;
    line-height: 28px;
  }
  .storypage_modalstoryflow__2L4ss {
    max-width: 100%;
  }
  .storypage_modalstoryflow__2L4ss h4 {
    font-size: 24px;
    line-height: 31px;
  }
  .storypage_modalstoryflow__2L4ss p {
    font-size: 16px;
    line-height: 21px;
  }
  .storypage_modalstoryflow__2L4ss .storypage_modalstoryflowSubdiv__Ngae7 p {
    font-size: 14px;
    line-height: 18px;
  }
  .storypage_modalstoryflow__2L4ss input {
    font-size: 18px;
    line-height: 23px;
    padding: 10px;
    margin-bottom: 30px;
    border-image-width: 16px;
    margin-top: 8px;
  }
  .storypage_modalstoryflow__2L4ss button {
    margin: 0 5px;
    font-size: 20px;
    width: 45%;
    padding: 7px 0;
  }
  .storypage_sharebtnlink__TJ10S .storypage_sharebtnimg__J6hf- {
    right: 0;
    position: absolute;
    top: -4%;
    width: 40px;
  }
  .storypage_modalMyStories__bsi\\+7 .storypage_sharebtnlink__TJ10S p {
    visibility: hidden;
    margin-bottom: 0;
    line-height: 25px;
  }
  .storypage_modalMyStories__bsi\\+7 .storypage_modalMyStoriesMobile__U0lr4 {
    display: flex;
    flex-wrap: wrap;
  }
  .storypage_modalMyStories__bsi\\+7 {
    right: 0;
    top: inherit;
    bottom: 0;
    width: 100%;
  }
  .storypage_modalMyStories__bsi\\+7 .storypage_sharebtnlink__TJ10S {
    border: 0;
    border-radius: 0;
    width: 100%;
  }
  .storypage_modalMyStories__bsi\\+7 .storypage_modalMyStoriesMobile__U0lr4 a {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (max-width: 400px) {
  .storypage_modalFooterMain__rFF2X h2 {
    font-size: 28px;
    line-height: 35px;
  }
  .storypage_modalmuniaModal__OaW3F p {
    font-size: 13px;
  }
  .storypage_ModalEditSubmission_Draft__ROV2c .storypage_ModalEditSubmission_DraftInner__KDucq button {
    padding: 0;
    font-size: 19px;
  }
  .storypage_modalstoryflow__2L4ss {
    padding: 20px;
  }
  .storypage_modalstoryflow__2L4ss button {
    padding: 5px;
  }
  .storypage_ModalpacakageNextcontent__bwdkW .storypage_StoryFlowInfoBtn__BhD90 button br {
    display: none;
  }
  .storypage_modalAvatar__DQNG6 img {
    width: 150px;
  }
  .storypage_modalAvatar__DQNG6 p {
    font-size: 30px;
    line-height: 36px;
  }
}
@media (max-width: 575px) {
  .storypage_ModalSelectIngredientStory__saNSf {
    width: 95%;
  }
  .storypage_modalpackage__OjhVY .storypage_modalIngredientsInner__0u8hx img {
    width: 180px;
  }
  .storypage_ModalpacakageNextcontent__bwdkW p {
    font-size: 18px;
    line-height: 22px;
  }
  .storypage_ModalpacakageNextcontent__bwdkW .storypage_StoryFlowInfoBtn__BhD90 button {
    font-size: 20px;
    line-height: 23px;
    padding: 0 45px;
  }
  .storypage_ModalpacakageNextcontent__bwdkW .storypage_StoryFlowInfoBtn__BhD90 button img {
    left: -42px;
    top: -30px;
    width: 83px;
  }
  .storypage_ModalStoryPage__emFbl .storypage_ModalStoryPageInner__GmIEz button {
    padding: 8px 10px;
    font-size: 20px;
    line-height: 25px;
  }
  .storypage_ModalStoryPage__emFbl .storypage_ModalStoryPageInner__GmIEz p,
  .storypage_ModalStoryPage__emFbl button {
    font-size: 20px;
    line-height: 24px;
  }
  .storypage_swiperNavBannertwo__gXCVh button img {
    max-width: 100%;
    width: 50px;
  }
  .storypage_ModalStoryPage__emFbl .storypage_cardNew__jcexU img {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .storypage_ModalStoryPage__emFbl .storypage_cardNew__jcexU {
    width: 200px;
  }
  .storypage_ModalStoryPage__emFbl {
    margin-top: 22%;
    padding-bottom: 25px;
  }
  .storypage_ModalStoryPage__emFbl .storypage_NewCardMAinStoryModal__oO-K4 {
    height: 15em !important;
  }
  .storypage_ModalStoryPage__emFbl h1 {
    margin-bottom: 10px;
  }
  .storypage_ModalStoryPage__emFbl .storypage_swiperSection_InfoDe__Oj571:nth-child(2n) {
    rotate: 10deg !important;
  }
  .storypage_ModalStoryPage__emFbl .storypage_swiperSection_InfoDe__Oj571:nth-child(odd) {
    rotate: -10deg !important;
  }
  .storypage_ModalStoryPage__emFbl .storypage_swiperSection_InfoDe__Oj571:last-child {
    rotate: 0deg !important;
  }
  .storypage_ModalStoryPage__emFbl .storypage_swiperSection_InfoDe__Oj571 .storypage_cardFooter__ArMFp span {
    margin-bottom: 0;
  }
  .storypage_modalmuniaModalMain__U57b2 .storypage_sharebtnimg__J6hf- {
    width: 56px;
    right: -10px;
  }
  .storypage_modalmuniaModal__OaW3F {
    padding: 0 10px 10px;
  }
  .storypage_modalmuniaModal__OaW3F h5 {
    font-size: 21px;
    line-height: 32px;
  }
  .storypage_modalmuniaModal__OaW3F .storypage_modalmuniaModalTop__vpKLs img {
    width: 150px;
  }
  .storypage_modalmuniaModal__OaW3F .storypage_modalmuniaModalTop__vpKLs .storypage_modalmuniaHelloImg__HXs5o {
    margin-left: 0;
    width: 200px;
  }
  .storypage_modalmuniaModalMain__U57b2 {
    margin-top: 15%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/StoryPage/storypage.module.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;AACA;;;EAGE,2BAA2B;AAC7B;AACA;;;EAGE,kCAAkC;AACpC;AACA;;;EAGE,OAAO;EACP,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,qDAAuD;EACvD,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qDAAuD;EACvD,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;;;;;;;EAOE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6DAAiE;EACjE,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;EACb,6DAAmE;EACnE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,qDAA8D;EAC9D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,qDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6DAAiE;EACjE,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,6DAAmE;EACnE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,eAAe;AACjB;AACA;;;EAGE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qDAA6D;EAC7D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6DAAsE;EACtE,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,8DAA0E;EAC1E,YAAY;EACZ,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,sDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,UAAU;AACZ;AACA;;;;;EAKE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,qBAAqB;EACvB;EACA;;IAEE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;IACX,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,QAAQ;IACR,eAAe;EACjB;EACA;;;;;IAKE,WAAW;EACb;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,aAAa;EACf;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,QAAQ;EACR,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,0DAAyE;EAC3E;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;;;;;IAKE,WAAW;EACb;EACA;;IAEE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;;;IAGE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,SAAS;IACT,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;IAIE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,OAAO;IACP,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;IACf,UAAU;IACV,cAAc;EAChB;EACA;IACE,QAAQ;IACR,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,WAAW;EACb;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,aAAa;IACb,cAAc;EAChB;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,WAAW;IACX,UAAU;IACV,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".modal,\n.modaltwo {\n  border: 0;\n  position: fixed;\n  right: 0;\n  background-color: #1d1d1c59;\n  width: 100%;\n}\n.ReactModal__Overlay--after-open,\n.modal,\n.modaltwo {\n  background-color: #1d1d1c59;\n}\n.btnFill,\n.modalstoryflow h4,\n.modalstoryflow input {\n  font-family: Kodchasan, sans-serif;\n}\n.modal,\n.modalconfirm,\n.modaltwo {\n  left: 0;\n  bottom: 0;\n  height: 100%;\n}\n.modal {\n  padding-top: 12%;\n}\n.modaltwo {\n  padding-top: 7%;\n}\n.modalEditProfile {\n  background: #d9eb41;\n  border: 5px solid #000;\n  border-radius: 65px;\n  text-align: center;\n  margin: auto;\n  width: 75%;\n  padding: 30px;\n}\n.modalEditProfile button {\n  display: block;\n  margin: 0 auto 20px;\n}\n.modalEditProfile p {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  text-align: center;\n  color: #1c2452;\n  margin-bottom: 25px;\n}\n.modalEditProfile button {\n  font-size: 25px;\n}\n.modalEditProfile .profile_top_img img {\n  max-width: 125px;\n}\n.Catputure {\n  flex-direction: row;\n  flex: 1;\n  display: flex;\n  margin-top: 15px;\n}\n.btnFill,\n.btnUnfill {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  padding: 0 50px;\n  margin: 0 10px;\n  text-align: center;\n}\n.btnUnfill {\n  border: 3px solid #0d5268;\n  background-color: transparent;\n  border-image: url(../../assets/images/border-image.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 11px;\n  border-image-outset: 0 0 8px 0;\n  color: #0d5268;\n}\n.btnFill {\n  color: #fff;\n  background-color: #0d5268;\n  border-image: url(../../assets/images/border-image.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 11px;\n  border-image-outset: 8px 8px 14px 8px;\n}\n.modalstoryflow {\n  background: #f2dd4e;\n  border: 3px solid #000;\n  border-radius: 6px;\n  max-width: 50%;\n  margin: auto;\n  padding: 30px;\n  text-align: center;\n}\n.modalstoryflow h4 {\n  text-align: center;\n  font-size: 30px;\n  margin-bottom: 10px;\n}\n.modalstoryflow p {\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 31px;\n  text-align: center;\n  margin-bottom: 33px;\n}\n.modalstoryflow .modalstoryflowSubdiv p {\n  margin-bottom: 0;\n  text-align: left;\n}\n.modalstoryflow input {\n  background: #fff;\n  border-radius: 15px;\n  width: 100%;\n  padding: 15px;\n  margin-bottom: 30px;\n  font-size: 22px;\n  font-weight: 600;\n  border-image: url(../../assets/images/EditStoryModalBOrder.png);\n  border-image-repeat: stretch;\n  border-image-slice: 16;\n  border-image-width: 19px;\n  border-image-outset: 1;\n  border-style: solid;\n  margin-top: 10px;\n}\n.ModalStoryPage,\n.modalIngredients {\n  border: 5px solid #000;\n  text-align: center;\n  margin: auto;\n}\n.modalstoryflow button {\n  margin: 0 15px;\n}\n.modalMyStories {\n  position: absolute;\n  right: 10%;\n  top: 25%;\n}\n.ModalStoryPage,\n.modalAvatar,\n.modalFooterMain,\n.modalIngredients,\n.modalIngredientsshareMobile,\n.modalmuniaModalMain,\n.modalpackage {\n  position: relative;\n}\n.modalIngredients {\n  background: #f2dd4e;\n  border-radius: 65px 65px 0 0;\n  padding: 30px;\n  width: 80%;\n  border-bottom: 0;\n}\n.modalIngredients p {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 47px;\n  color: #000;\n  margin-bottom: 36px;\n}\n.modalIngredients .modalIngredientsInner {\n  background: #56cdd5;\n  transform: matrix(1, -0.09, 0.07, 1, 0, 0);\n  border: 4px solid #000;\n  position: relative;\n  width: 50%;\n  margin: auto;\n  padding-top: 20px;\n  z-index: 1;\n}\n.modalpackage .modalIngredientsInner::before {\n  content: \"\";\n  position: absolute;\n  top: 10%;\n  left: 28%;\n  width: 89px;\n  height: 87px;\n  background: url(../../assets/images/ingredientstop.png) no-repeat;\n  z-index: -1;\n}\n.modalpackage .modalIngredientsInner::after {\n  content: \"\";\n  position: absolute;\n  bottom: 15%;\n  right: 23%;\n  width: 185px;\n  height: 122px;\n  background: url(../../assets/images/ingredientbottom.png) no-repeat;\n  z-index: -1;\n}\n.modalIngredients .modalIngredientsInnerInfo {\n  background: #232876;\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 20px;\n}\n.modalIngredients .modalIngredientsInnerInfo img {\n  width: 57px;\n  margin-right: 10px;\n}\n.modalIngredients .modalIngredientsInnerInfo .modalIngredientsInnerInfoimg img {\n  width: 95px;\n}\n.modalIngredients .modalIngredientsInnerInfo span {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  text-align: center;\n  color: #fff;\n}\n.modalIngredients .modalIngredientsInner p {\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n.modalIngredients .HeartYellowbtn {\n  position: absolute;\n  bottom: 5%;\n  right: 10%;\n}\n.modalIngredientsshare {\n  width: 80%;\n  margin: auto;\n  background: #0d5268;\n  border-radius: 0 0 65px 65px;\n  padding: 16px 54px;\n  border: 4px solid #000;\n}\n.modalIngredientsshare p {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #fff;\n}\n.modalIngredientsshare a,\n.modalIngredientsshareMobile .modalIngredientsshareInner a {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  color: #fff;\n  text-align: center;\n}\n.modalIngredientsshare a span,\n.modalIngredientsshareMobile .modalIngredientsshareInner a span {\n  display: block;\n}\n.modalIngredientsshare .modalIngredientsshareInner {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 15px;\n}\n.modalIngredientsshare .modalIngredientsshareInner img {\n  width: 118px;\n}\n.modalpackage .modalIngredientsInner {\n  background: 0 0;\n  transform: unset;\n  border: 0;\n}\n.ModalpacakageNextcontent {\n  background: #56cdd5;\n  border-radius: 0 0 65px 65px;\n  width: 70%;\n  margin: auto;\n  border: 5px solid #000;\n  text-align: center;\n  padding: 23px 74px;\n}\n.ModalpacakageNextcontent .StoryFlowInfoBtn button {\n  margin-top: 40px;\n  line-height: 36px;\n}\n.ModalpacakageNextcontent .StoryFlowInfoBtn button img {\n  left: -58px;\n  top: -53px;\n  width: 133px;\n}\n.ModalpacakageNextcontent .StoryFlowInfoBtn {\n  margin-top: -90px;\n}\n.ModalpacakageNextcontent p {\n  font-weight: 500;\n  font-size: 36px;\n  line-height: 42px;\n  color: #1c2452;\n  border-image: url(../../assets/images/dark-blue-border-img.png);\n  border-image-repeat: stretch;\n  border-image-slice: 16;\n  border-image-width: 15px;\n  border-image-outset: inherit;\n  border-style: solid;\n  padding: 30px 0 90px;\n}\n.storypage_modalpackage .modalIngredientsInner::before {\n  top: 6%;\n  left: -16px;\n}\n.storypage_modalpackage .modalIngredientsInner::after {\n  bottom: 15%;\n  right: -90px;\n}\n.modalAvatar {\n  background: #d9eb41;\n  border-image: url(../../assets/images/yellow-border-modal.png);\n  border-image-repeat: stretch;\n  border-image-slice: 16;\n  border-image-width: 15px;\n  border-image-outset: 8px;\n  border-style: solid;\n  padding: 50px 0 20px;\n  width: 50%;\n  text-align: center;\n  margin: auto;\n  z-index: 10;\n}\n.modalAvatar img {\n  width: 211px;\n}\n.modalAvatar p {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  margin: 10px 0 35px;\n}\n.ModalEditSubmission_Draft {\n  background: #0d5268;\n  border: 1px solid #000;\n  width: 78%;\n  margin: auto;\n  text-align: center;\n  padding: 32px;\n  border-image: url(../../assets/images/behind-bg-section.png);\n  border-image-repeat: stretch;\n  border-image-slice: 16;\n  border-image-width: 10px;\n  border-image-outset: 11px;\n}\n.ModalEditSubmission_Draft .ModalEditSubmission_DraftInner h2 {\n  color: #fff;\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 56px;\n  margin-bottom: 39px;\n}\n.ModalEditSubmission_Draft .ModalEditSubmission_DraftInner p {\n  font-weight: 600;\n  font-size: 34px;\n  line-height: 39px;\n  text-align: center;\n  color: #fff;\n  margin-bottom: 38px;\n}\n.ModalEditSubmission_Draft .ModalEditSubmission_DraftInner p span {\n  display: block;\n  margin: 20px 0;\n}\n.ModalEditSubmission_Draft .ModalEditSubmission_DraftInner button {\n  color: #0d5268;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  background: #d9eb41;\n  padding: 10px 15px;\n  border-image: url(../../assets/images/yellow-border-img.png);\n  border-image-repeat: stretch;\n  border-image-slice: 16;\n  border-image-width: 10px;\n  border-image-outset: 9px;\n  border-style: solid;\n}\n.ModalStoryPage {\n  background: #dffdff;\n  border-radius: 51px;\n  padding: 15px;\n  width: 415px;\n}\n.ModalStoryPage p {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 28px;\n  text-align: center;\n  color: #0d5268;\n  margin-bottom: 15px;\n}\n.ModalStoryPage h1 {\n  font-family: \"Roof runners active\";\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 41px;\n  text-align: center;\n  color: #0d5268;\n  margin-bottom: -8px;\n}\n.ModalStoryPage button {\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 31px;\n}\n.ModalStoryPage span {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 25px;\n  text-align: center;\n  color: #000;\n  margin: 20px 0 10px;\n  display: block;\n}\n.ModalStoryPage .ModalStoryPageInner p {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 25px;\n  text-align: center;\n  color: #000;\n}\n.ModalStoryPage .ModalStoryPageInner button {\n  padding: 8px 20px;\n  font-size: 22px;\n  line-height: 31px;\n}\n.ModalStoryPage .sharebtnimg {\n  position: absolute;\n  top: -2%;\n  right: -15px;\n  cursor: pointer;\n  width: 50px;\n}\n.modalIngredients .modalIngredientsInner::before {\n  content: \"\";\n  position: absolute;\n  top: 5%;\n  left: 5px;\n  width: 89px;\n  height: 87px;\n  background: url(../../assets/images/ingredientstop.png) no-repeat;\n  z-index: -1;\n}\n.modalIngredients .modalIngredientsInner::after {\n  content: \"\";\n  position: absolute;\n  bottom: 24%;\n  right: -12px;\n  width: 185px;\n  height: 122px;\n  background: url(../../assets/images/ingredientbottom.png) no-repeat;\n  z-index: -1;\n}\n.modalpackage {\n  background: #f2dd4e;\n  border: 5px solid #000;\n  border-radius: 65px 65px 0 0;\n  padding: 30px;\n  width: 70%;\n  margin: auto;\n  text-align: center;\n  border-bottom: 0;\n  z-index: 1;\n}\n.modalIngredientsshareMobile {\n  background: #0d5268;\n  border-radius: 0 0 6px 6px;\n  padding: 17px 0;\n  border: 4px solid #000;\n}\n.modalIngredientsshareMobile .modalIngredientsshareInner a img {\n  width: 80px;\n}\n.modalIngredientsshareMobile .modalIngredientsshareInner {\n  display: flex;\n  justify-content: space-around;\n}\n.modalmuniaModal {\n  background: #0d5268;\n  border: 5px solid #000;\n  border-radius: 42px;\n  text-align: center;\n  padding: 0 20px 10px;\n  width: 60%;\n  margin: auto;\n}\n.NoDraftModal,\n.modalFooterMain {\n  text-align: center;\n  background: #56cdd5;\n  border: 4px solid #000;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n}\n.modalmuniaModalMain .sharebtnimg {\n  position: absolute;\n  top: -20px;\n  right: 17%;\n  cursor: pointer;\n}\n.NoDraftModal .sharebtnimg,\n.SubmittedSuccesModal .sharebtnimg,\n.modalFooterMain .sharebtnimg {\n  top: -14px;\n  right: -15px;\n  position: absolute;\n}\n.modalmuniaModal h5 {\n  text-align: center;\n  color: #fff;\n  font-size: 25px;\n  line-height: 35px;\n}\n.modalmuniaModal p {\n  font-style: italic;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n  color: #fff;\n}\n.NoDraftModal h2,\n.SubmittedSuccesModal h2,\n.modalFooterMain h2 {\n  font-size: 48px;\n  line-height: 58px;\n}\n.modalmuniaModal .modalmuniaInner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 15px 0;\n}\n.modalmuniaModal .modalmuniaInner a {\n  font-style: italic;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 21px;\n  color: #fff;\n  margin-right: 12px;\n}\n.modalmuniaModal .modalmuniaInner img {\n  margin-right: 12px;\n}\n.modalmuniaModal .modalmuniabtn button {\n  border-image: url(../../assets/images/white-border-image.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 11px;\n  border-image-outset: 0;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  color: #fff;\n  border-style: solid;\n  display: inline-block;\n  background: 0 0;\n  padding: 10px 15px;\n}\n.modalmuniaModal .modalmuniaModalTop img:first-child {\n  width: 100px;\n}\n.modalmuniaModal .modalmuniaModalTop .modalmuniaHelloImg {\n  margin-left: -35px;\n  width: 160px;\n}\n.modalFooterMain {\n  border-radius: 52px;\n  padding: 30px;\n}\n.modalFooterMain .sharebtnimg {\n  cursor: pointer;\n}\n.modalFooterMain h2 {\n  margin: 10px 0 45px;\n}\n.NoDraftModal {\n  padding: 50px;\n  width: 65%;\n  border-radius: 52px;\n  position: relative;\n  margin: auto;\n}\n.SubmittedSuccesModal,\n.modalLoginRegister {\n  border: 4px solid #000;\n  position: relative;\n  text-align: center;\n}\n.NoDraftModal h2 {\n  margin: 30px 0;\n}\n.NoDraftModal .NoDraftFrame {\n  width: 150px;\n}\n.SubmittedSuccesModal {\n  background: #d9eb41;\n  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);\n  border-radius: 52px;\n  padding: 30px;\n  width: 65%;\n  margin: auto;\n}\n.SubmittedSuccesModal h2 {\n  margin: 35px 0 45px;\n}\n.modalLoginRegister {\n  background: #f2dd4e;\n  border-radius: 50px;\n  padding: 80px 30px 50px;\n  z-index: 1;\n}\n.modalLoginRegister .sharebtnimg {\n  position: absolute;\n  top: -20px;\n  right: -20px;\n  cursor: pointer;\n}\n.modalLoginRegister button {\n  display: inline-block;\n  margin: 35px 15px;\n  width: 35%;\n}\n.modalLoginRegister::before {\n  content: \"\";\n  position: absolute;\n  top: 25px;\n  right: 15px;\n  background: url(../../assets/images/login-first-badalbg.png) no-repeat;\n  width: 124px;\n  height: 123px;\n  z-index: -1;\n}\n.modalLoginRegister::after {\n  content: \"\";\n  position: absolute;\n  bottom: 130px;\n  left: 0;\n  background: url(../../assets/images/login-first-red-line-bg.png) no-repeat;\n  width: 146px;\n  height: 102px;\n}\n.ModalSelectIngredientStory {\n  background: #56cdd5;\n  border: 4px solid #000;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 52px;\n  position: relative;\n  text-align: center;\n  padding: 40px;\n}\n.ModalSelectIngredientStory .backbtn {\n  position: absolute;\n  right: -12px;\n  top: -12px;\n}\n.ModalSelectIngredientStory img.NoDraftFrame {\n  width: 125px;\n  margin: auto;\n}\n.ModalSelectIngredientStory h2 {\n  font-weight: 700;\n  font-size: 64px;\n  line-height: 77px;\n  text-align: center;\n  color: #000;\n  margin: 30px 0;\n}\n.ModalStoryPicker {\n  border: 5px solid #000;\n  border-radius: 60px;\n  text-align: center;\n}\n.ModalStoryPicker .ModalStoryPickerTop {\n  background: #56cdd5;\n  border-radius: 60px 60px 0 0;\n  padding: 20px;\n}\n.ModalStoryPicker .ModalStoryPickerBottom {\n  background: #f2dd4e;\n  border-radius: 0 0 60px 60px;\n  padding: 20px;\n  margin-top: -2px;\n}\n.ModalStoryPicker .ModalStoryPickerTop .ModalStoryPickerTopInner {\n  display: flex;\n  justify-content: center;\n}\n.ModalStoryPickerTop p {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 42px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 15px;\n}\n.ModalStoryPicker .dashedLine {\n  background: #f2dd4e;\n}\n.ModalStoryPicker .ModalStoryPickerBottom button {\n  margin-top: 22px;\n}\n.ModalStoryPicker .ModalStoryPickerBottom button.storyBtn {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n  padding: 12px 30px !important;\n  background: #56cdd5;\n  border-image: url(../../assets/images/StoryBorderCreate.png);\n  border-image-repeat: stretch;\n  border-image-slice: 27;\n  border-image-width: 25px;\n  border-image-outset: 5px;\n  border-radius: 40px;\n  border-style: solid;\n  margin-top: 0;\n}\n.ModalStoryPicker .ModalStoryPickerBottom p {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 31px;\n  text-align: center;\n  color: #000;\n  margin: 10px 0;\n}\n.ModalStoryPickerTop .ModalStoryPickerTopInner p {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 0;\n}\n.ModalStoryPickerBottom .CarouselPara p {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  text-align: center;\n  color: #000;\n}\n.ModalStoryPickerTop .ModalStoryPickerTopInner img {\n  width: 188px;\n  margin: 0 15px;\n}\n.ModalEditSubmission_Draft a {\n  top: -12px;\n}\n.newScreenModal .modalIngredients {\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n  height: 100vh;\n  overflow: hidden;\n}\n.newScreenModal .modalIngredients .modalIngredientsInner {\n  width: 110%;\n  margin: 45px -30px 43px -17px;\n  z-index: 0;\n}\n.newScreenModal\n  .modalIngredients\n  .modalIngredientsInner\n  .modalIngredientsInnerInfo\n  span {\n  font-size: 24px !important;\n  line-height: 31px !important;\n}\n.newScreenModal .modalIngredients .HeartYellowbtn {\n  position: inherit;\n  bottom: 5%;\n  right: inherit;\n  text-align: right;\n  width: auto;\n}\n.modalstoryflow button {\n  width: 43%;\n}\n.NoDraftModal .sharebtnimg,\n.SubmittedSuccesModal .sharebtnimg {\n  width: 80px;\n  cursor: pointer;\n}\n@media (max-width: 1199px) {\n  .modalAvatar .modalAvatarLeftImg {\n    left: 40px !important;\n  }\n  .ModalEditSubmission_Draft,\n  .modalAvatar {\n    width: 100%;\n  }\n  .modalAvatar .modalAvatarRightImg {\n    right: 75px !important;\n  }\n  .modalmuniaModalMain .sharebtnimg {\n    right: 13%;\n    cursor: pointer;\n  }\n  .modalmuniaModal {\n    width: 70%;\n  }\n  .modalIngredients .modalIngredientsInner::before {\n    left: 12%;\n  }\n  .modalIngredients .modalIngredientsInner::after {\n    bottom: 30%;\n    right: 0;\n  }\n  .modalpackage .modalIngredientsInner::after {\n    right: 92px;\n  }\n  .modalpackage .modalIngredientsInner::before {\n    left: 22%;\n  }\n  .ModalpacakageNextcontent p {\n    font-size: 25px;\n    line-height: 30px;\n  }\n  .ModalpacakageNextcontent {\n    padding: 23px 25px;\n    width: 70%;\n  }\n  .modalIngredients,\n  .modalIngredientsshare {\n    width: 75%;\n  }\n  .ModalpacakageNextcontent .StoryFlowInfoBtn button {\n    font-size: 25px;\n    line-height: 30px;\n    padding: 0 65px;\n  }\n  .modalIngredients .modalIngredientsInner {\n    width: 90%;\n  }\n  .modalIngredientsshare .modalIngredientsshareInner img {\n    width: 80px;\n  }\n  .modalstoryflow {\n    max-width: 75%;\n  }\n}\n@media (max-width: 991px) {\n  .modalLoginRegister .sharebtnimg {\n    width: 18%;\n    cursor: pointer;\n  }\n  .modalLoginRegister {\n    width: 100%;\n    margin: auto;\n  }\n  .modalmuniaModalMain .sharebtnimg {\n    right: 0;\n    cursor: pointer;\n  }\n  .ModalpacakageNextcontent,\n  .modalIngredients,\n  .modalIngredientsshare,\n  .modalmuniaModal,\n  .modalpackage {\n    width: 100%;\n  }\n  .ModalStoryPage {\n    margin-top: 3%;\n  }\n}\n@media (min-width: 768px) {\n  .modalIngredients .sharebtnMobile,\n  .modalIngredientsshareMobile {\n    display: none;\n  }\n}\n@media (max-width: 450px) {\n  .modalLoginRegister {\n    width: 100%;\n  }\n}\n.modalconfirm {\n  border: 0;\n  background-color: #1d1d1c59;\n  position: fixed;\n  right: 0;\n  width: 100%;\n}\n.modalMyStories .sharebtnlink {\n  width: 168px;\n  padding: 15px 33px;\n  background: #0d5268;\n  border: 4px solid #000;\n  border-radius: 10px;\n  text-align: center;\n  position: relative;\n}\n.sharebtnlink .sharebtnimg {\n  position: absolute;\n  top: -4%;\n  right: -25%;\n}\n.sharebtnlink p {\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 40px;\n  color: #fff;\n  margin-bottom: 22px;\n}\n.sharebtnlink img {\n  width: 70px;\n}\n.sharebtnlink a {\n  margin-bottom: 20px;\n  display: block;\n}\n.sharebtnlink span {\n  font-weight: 600;\n  font-size: 19px;\n  line-height: 25px;\n  color: #fff;\n}\n@media (max-width: 767px) {\n  .ModalEditSubmission_Draft {\n    margin-top: 70px;\n  }\n  .ModalStoryPicker .ModalStoryPickerTop .ModalStoryPickerTopInner,\n  .modalMyStories .modalMyStoriesMobile a span {\n    display: block;\n  }\n  .ModalStoryPicker .ModalStoryPickerTop .ModalStoryPickerTopInner p {\n    font-size: 22px;\n    line-height: 28px;\n    margin: 20px 0;\n  }\n  .modalLoginRegister button {\n    width: 85%;\n    margin: 15px;\n  }\n  .modalLoginRegister h2 {\n    margin-bottom: 15px;\n    font-size: 30px;\n    line-height: 40px;\n  }\n  .modalLoginRegister {\n    padding: 30px 40px;\n  }\n  .modalLoginRegister::before {\n    top: 10px;\n    right: 0;\n    width: 70px;\n    height: 70px;\n    background-image: url(../../assets/images/mobile-login-first-badalbg.png);\n  }\n  .modalLoginRegister::after {\n    z-index: -1;\n    bottom: 7px;\n  }\n  .NoDraftModal,\n  .SubmittedSuccesModal,\n  .modalEditProfile,\n  .modalIngredients,\n  .modalLoginRegister {\n    width: 100%;\n  }\n  .NoDraftModal .sharebtnimg,\n  .SubmittedSuccesModal .sharebtnimg {\n    width: 60px;\n  }\n  .SubmittedSuccesModal h2 {\n    font-size: 40px;\n    line-height: 45px;\n  }\n  .ModalMainNew {\n    justify-content: space-around;\n  }\n  .modalAvatar .modalAvatarLeftImg {\n    left: 19px !important;\n    top: -12px !important;\n  }\n  .modalAvatar .modalAvatarRightImg {\n    right: 30px !important;\n  }\n  .modalEditProfile p {\n    font-size: 18px;\n    line-height: 23px;\n  }\n  .modalEditProfile button {\n    font-size: 18px;\n    line-height: 29px;\n  }\n  .ModalEditSubmission_Draft a {\n    top: -5px;\n  }\n  .modalFooterMain .sharebtnimg {\n    width: 50px;\n  }\n  .NoDraftModal h2 {\n    font-size: 35px;\n    line-height: 45px;\n  }\n  .NoDraftModal .NoDraftFrame {\n    width: 100px;\n  }\n  .ModalSelectIngredientStory {\n    width: 75%;\n    margin: auto;\n    padding: 30px 20px;\n  }\n  .ModalSelectIngredientStory img.NoDraftFrame {\n    width: 75px;\n  }\n  .ModalSelectIngredientStory h2 {\n    font-size: 40px;\n    line-height: 48px;\n    margin: 20px 0;\n  }\n  .ModalSelectIngredientStory h2 br,\n  .modalIngredientsshare,\n  .modalstoryflow p br {\n    display: none;\n  }\n  .modalLoginRegister .sharebtnimg {\n    width: 50px;\n    right: -11px;\n    top: -10px;\n    cursor: pointer;\n  }\n  .modalFooterMain h2 {\n    font-size: 40px;\n    line-height: 48px;\n    margin: 15px 0 30px;\n  }\n  .modalmuniaModal p {\n    font-size: 15px;\n    line-height: 21px;\n  }\n  .modalIngredients .HeartYellowbtn {\n    bottom: 0;\n    right: 3%;\n    width: 50px;\n  }\n  .ModalStoryPage {\n    margin-top: 2%;\n    width: 100%;\n  }\n  .ModalStoryPage button {\n    font-size: 26px;\n    line-height: 31px;\n  }\n  .modalIngredients p {\n    font-size: 25px;\n    line-height: 30px;\n  }\n  .modalpackage .modalIngredientsInner img {\n    width: 40%;\n  }\n  .modalIngredients .modalIngredientsInner img {\n    width: 65%;\n  }\n  .modalIngredients .modalIngredientsInner .modalIngredientsInnerInfo img {\n    width: 30%;\n  }\n  .modalIngredients .modalIngredientsInner .modalIngredientsInnerInfo {\n    text-align: left;\n  }\n  .modalIngredients .modalIngredientsInner .modalIngredientsInnerInfo span {\n    font-size: 18px;\n    line-height: 25px;\n  }\n  .modalIngredients\n    .modalIngredientsInner\n    .modalIngredientsInnerInfo\n    .modalIngredientsInnerInfoimg {\n    text-align: right;\n  }\n  .modalIngredients .modalIngredientsInner .modalIngredientsInnerInfoimg img {\n    width: 50%;\n    margin-right: 30px;\n  }\n  .modalpackage .modalIngredientsInner::after {\n    bottom: 17%;\n    right: 21px;\n  }\n  .modalpackage .modalIngredientsInner::before {\n    top: 4%;\n    left: 20%;\n  }\n  .ModalpacakageNextcontent p {\n    font-size: 22px;\n    line-height: 25px;\n    padding: 15px 0 70px;\n  }\n  .ModalEditSubmission_Draft {\n    width: 100%;\n    padding: 10px 10px 20px;\n  }\n  .ModalEditSubmission_Draft .ModalEditSubmission_DraftInner p {\n    font-size: 18px !important;\n    line-height: 21px !important;\n  }\n  .ModalEditSubmission_Draft .ModalEditSubmission_DraftInner button {\n    font-size: 24px;\n    line-height: 31px;\n    padding: 5px 10px;\n  }\n  .ModalEditSubmission_Draft .ModalEditSubmission_DraftInner h2 {\n    font-size: 24px;\n    line-height: 28px;\n  }\n  .modalstoryflow {\n    max-width: 100%;\n  }\n  .modalstoryflow h4 {\n    font-size: 24px;\n    line-height: 31px;\n  }\n  .modalstoryflow p {\n    font-size: 16px;\n    line-height: 21px;\n  }\n  .modalstoryflow .modalstoryflowSubdiv p {\n    font-size: 14px;\n    line-height: 18px;\n  }\n  .modalstoryflow input {\n    font-size: 18px;\n    line-height: 23px;\n    padding: 10px;\n    margin-bottom: 30px;\n    border-image-width: 16px;\n    margin-top: 8px;\n  }\n  .modalstoryflow button {\n    margin: 0 5px;\n    font-size: 20px;\n    width: 45%;\n    padding: 7px 0;\n  }\n  .sharebtnlink .sharebtnimg {\n    right: 0;\n    position: absolute;\n    top: -4%;\n    width: 40px;\n  }\n  .modalMyStories .sharebtnlink p {\n    visibility: hidden;\n    margin-bottom: 0;\n    line-height: 25px;\n  }\n  .modalMyStories .modalMyStoriesMobile {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .modalMyStories {\n    right: 0;\n    top: inherit;\n    bottom: 0;\n    width: 100%;\n  }\n  .modalMyStories .sharebtnlink {\n    border: 0;\n    border-radius: 0;\n    width: 100%;\n  }\n  .modalMyStories .modalMyStoriesMobile a {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n@media (max-width: 400px) {\n  .modalFooterMain h2 {\n    font-size: 28px;\n    line-height: 35px;\n  }\n  .modalmuniaModal p {\n    font-size: 13px;\n  }\n  .ModalEditSubmission_Draft .ModalEditSubmission_DraftInner button {\n    padding: 0;\n    font-size: 19px;\n  }\n  .modalstoryflow {\n    padding: 20px;\n  }\n  .modalstoryflow button {\n    padding: 5px;\n  }\n  .ModalpacakageNextcontent .StoryFlowInfoBtn button br {\n    display: none;\n  }\n  .modalAvatar img {\n    width: 150px;\n  }\n  .modalAvatar p {\n    font-size: 30px;\n    line-height: 36px;\n  }\n}\n@media (max-width: 575px) {\n  .ModalSelectIngredientStory {\n    width: 95%;\n  }\n  .modalpackage .modalIngredientsInner img {\n    width: 180px;\n  }\n  .ModalpacakageNextcontent p {\n    font-size: 18px;\n    line-height: 22px;\n  }\n  .ModalpacakageNextcontent .StoryFlowInfoBtn button {\n    font-size: 20px;\n    line-height: 23px;\n    padding: 0 45px;\n  }\n  .ModalpacakageNextcontent .StoryFlowInfoBtn button img {\n    left: -42px;\n    top: -30px;\n    width: 83px;\n  }\n  .ModalStoryPage .ModalStoryPageInner button {\n    padding: 8px 10px;\n    font-size: 20px;\n    line-height: 25px;\n  }\n  .ModalStoryPage .ModalStoryPageInner p,\n  .ModalStoryPage button {\n    font-size: 20px;\n    line-height: 24px;\n  }\n  .swiperNavBannertwo button img {\n    max-width: 100%;\n    width: 50px;\n  }\n  .ModalStoryPage .cardNew img {\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n  }\n  .ModalStoryPage .cardNew {\n    width: 200px;\n  }\n  .ModalStoryPage {\n    margin-top: 22%;\n    padding-bottom: 25px;\n  }\n  .ModalStoryPage .NewCardMAinStoryModal {\n    height: 15em !important;\n  }\n  .ModalStoryPage h1 {\n    margin-bottom: 10px;\n  }\n  .ModalStoryPage .swiperSection_InfoDe:nth-child(2n) {\n    rotate: 10deg !important;\n  }\n  .ModalStoryPage .swiperSection_InfoDe:nth-child(odd) {\n    rotate: -10deg !important;\n  }\n  .ModalStoryPage .swiperSection_InfoDe:last-child {\n    rotate: 0deg !important;\n  }\n  .ModalStoryPage .swiperSection_InfoDe .cardFooter span {\n    margin-bottom: 0;\n  }\n  .modalmuniaModalMain .sharebtnimg {\n    width: 56px;\n    right: -10px;\n  }\n  .modalmuniaModal {\n    padding: 0 10px 10px;\n  }\n  .modalmuniaModal h5 {\n    font-size: 21px;\n    line-height: 32px;\n  }\n  .modalmuniaModal .modalmuniaModalTop img {\n    width: 150px;\n  }\n  .modalmuniaModal .modalmuniaModalTop .modalmuniaHelloImg {\n    margin-left: 0;\n    width: 200px;\n  }\n  .modalmuniaModalMain {\n    margin-top: 15%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `storypage_modal__08wW0`,
	"modaltwo": `storypage_modaltwo__tPeSU`,
	"ReactModal__Overlay--after-open": `storypage_ReactModal__Overlay--after-open__pfg+Q`,
	"btnFill": `storypage_btnFill__Yovh4`,
	"modalstoryflow": `storypage_modalstoryflow__2L4ss`,
	"modalconfirm": `storypage_modalconfirm__vMvVE`,
	"modalEditProfile": `storypage_modalEditProfile__qEykb`,
	"profile_top_img": `storypage_profile_top_img__6HoMI`,
	"Catputure": `storypage_Catputure__gJVDN`,
	"btnUnfill": `storypage_btnUnfill__Gtvp2`,
	"modalstoryflowSubdiv": `storypage_modalstoryflowSubdiv__Ngae7`,
	"ModalStoryPage": `storypage_ModalStoryPage__emFbl`,
	"modalIngredients": `storypage_modalIngredients__eg6jc`,
	"modalMyStories": `storypage_modalMyStories__bsi+7`,
	"modalAvatar": `storypage_modalAvatar__DQNG6`,
	"modalFooterMain": `storypage_modalFooterMain__rFF2X`,
	"modalIngredientsshareMobile": `storypage_modalIngredientsshareMobile__B2ygl`,
	"modalmuniaModalMain": `storypage_modalmuniaModalMain__U57b2`,
	"modalpackage": `storypage_modalpackage__OjhVY`,
	"modalIngredientsInner": `storypage_modalIngredientsInner__0u8hx`,
	"modalIngredientsInnerInfo": `storypage_modalIngredientsInnerInfo__P6bsl`,
	"modalIngredientsInnerInfoimg": `storypage_modalIngredientsInnerInfoimg__sIn9G`,
	"HeartYellowbtn": `storypage_HeartYellowbtn__eMFOt`,
	"modalIngredientsshare": `storypage_modalIngredientsshare__1OpOR`,
	"modalIngredientsshareInner": `storypage_modalIngredientsshareInner__Ho9xT`,
	"ModalpacakageNextcontent": `storypage_ModalpacakageNextcontent__bwdkW`,
	"StoryFlowInfoBtn": `storypage_StoryFlowInfoBtn__BhD90`,
	"storypage_modalpackage": `storypage_storypage_modalpackage__Zt0Nk`,
	"ModalEditSubmission_Draft": `storypage_ModalEditSubmission_Draft__ROV2c`,
	"ModalEditSubmission_DraftInner": `storypage_ModalEditSubmission_DraftInner__KDucq`,
	"ModalStoryPageInner": `storypage_ModalStoryPageInner__GmIEz`,
	"sharebtnimg": `storypage_sharebtnimg__J6hf-`,
	"modalmuniaModal": `storypage_modalmuniaModal__OaW3F`,
	"NoDraftModal": `storypage_NoDraftModal__Coqa1`,
	"SubmittedSuccesModal": `storypage_SubmittedSuccesModal__Loe5Q`,
	"modalmuniaInner": `storypage_modalmuniaInner__GcajS`,
	"modalmuniabtn": `storypage_modalmuniabtn__-d0u0`,
	"modalmuniaModalTop": `storypage_modalmuniaModalTop__vpKLs`,
	"modalmuniaHelloImg": `storypage_modalmuniaHelloImg__HXs5o`,
	"modalLoginRegister": `storypage_modalLoginRegister__r6NDz`,
	"NoDraftFrame": `storypage_NoDraftFrame__KCqPo`,
	"ModalSelectIngredientStory": `storypage_ModalSelectIngredientStory__saNSf`,
	"backbtn": `storypage_backbtn__sOeCx`,
	"ModalStoryPicker": `storypage_ModalStoryPicker__L6OIH`,
	"ModalStoryPickerTop": `storypage_ModalStoryPickerTop__BMFxI`,
	"ModalStoryPickerBottom": `storypage_ModalStoryPickerBottom__QYwuI`,
	"ModalStoryPickerTopInner": `storypage_ModalStoryPickerTopInner__z47b5`,
	"dashedLine": `storypage_dashedLine__tSgnb`,
	"storyBtn": `storypage_storyBtn__+THNH`,
	"CarouselPara": `storypage_CarouselPara__HPD-b`,
	"newScreenModal": `storypage_newScreenModal__GZFZ4`,
	"modalAvatarLeftImg": `storypage_modalAvatarLeftImg__HHB5r`,
	"modalAvatarRightImg": `storypage_modalAvatarRightImg__WJM-f`,
	"sharebtnMobile": `storypage_sharebtnMobile__sJRoB`,
	"sharebtnlink": `storypage_sharebtnlink__TJ10S`,
	"modalMyStoriesMobile": `storypage_modalMyStoriesMobile__U0lr4`,
	"ModalMainNew": `storypage_ModalMainNew__-ApCg`,
	"swiperNavBannertwo": `storypage_swiperNavBannertwo__gXCVh`,
	"cardNew": `storypage_cardNew__jcexU`,
	"NewCardMAinStoryModal": `storypage_NewCardMAinStoryModal__oO-K4`,
	"swiperSection_InfoDe": `storypage_swiperSection_InfoDe__Oj571`,
	"cardFooter": `storypage_cardFooter__ArMFp`
};
export default ___CSS_LOADER_EXPORT___;
